// Sidebar.js
import React, { useState, forwardRef, useEffect } from 'react';
import { ChevronDown, ChevronRight, Check } from 'lucide-react';
import './Sidebar.css';

const Sidebar = forwardRef(({ extractedData, onLineItemsToggle, onFieldUpdate, onFieldActivate }, ref) => {
  const [expandedSections, setExpandedSections] = useState({
    basicInfo: true,
    lineItems: true,
    totalBill: true
  });
  useEffect(() => {
    console.log('Sidebar re-rendered with extractedData:', extractedData);
  }, [extractedData]);
  
  const toggleSection = (section) => {
    setExpandedSections(prev => {
      const newState = { ...prev, [section]: !prev[section] };
      if (section === 'lineItems') {
        onLineItemsToggle(newState.lineItems);
      }
      return newState;
    });
  };

  const [activeField, setActiveField] = useState(null);

  const renderField = (fieldKey, label, value, sectionType, lineItemIndex) => (
    <div
      className={`field ${activeField === fieldKey ? 'active' : ''}`}
      data-field={fieldKey}
      onClick={() => {
        setActiveField(fieldKey);
        onFieldActivate(fieldKey, lineItemIndex ?? null); 
      }}
      onMouseLeave={() => {
        setActiveField(null);
        onFieldActivate(null, null); // Reset when leaving
      }}
    >
      <div className="field-label">
        <Check size={16} className="check-icon" />
        {label}
      </div>
      <input
        type="text"
        className="field-value"
        value={value || ''}
        onChange={(e) => onFieldUpdate(fieldKey, e.target.value, lineItemIndex)}
      />
    </div>
  );
  const renderSection = (title, fields, sectionKey) => (
    <div className={`sidebar-section ${sectionKey} ${expandedSections[sectionKey] ? 'expanded' : ''}`}>
      <h3 onClick={() => toggleSection(sectionKey)}>
        {expandedSections[sectionKey] ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
        {title}
      </h3>
      {expandedSections[sectionKey] && (
        <div className="content">
          {fields.map(([fieldKey, value]) => {
            const label = fieldKey; // Map fieldKey to label if needed
            return renderField(fieldKey, label, value, sectionKey);
          })}
        </div>
      )}
    </div>
  );

  const { unique_fields = {}, total_bill = {}, line_items = [] } = extractedData || {};

  const basicInfoFields = Object.entries(unique_fields);
  const totalBillFields = Object.entries(total_bill);

  return (
    <div className="sidebar" ref={ref}>
      {renderSection('Basic Information', basicInfoFields, 'basicInfo')}
      {renderSection('Line Items', [['Line Items', `${line_items.length} items`]], 'lineItems')}
      {renderSection('Total Bill', totalBillFields, 'totalBill')}
    </div>
  );
});

export default Sidebar;
